import { useDispatch, useSelector } from "react-redux";
import { requestModule } from "./modules/auth";

import type { TypedUseSelectorHook } from "react-redux";
import type { Action, AsyncThunkAction } from "@reduxjs/toolkit";
import type { AppState, AppDispatch, ActionStoreParams } from "./store";

type ActionType = AsyncThunkAction<unknown, unknown, ActionStoreParams>;
type AnyAction = ActionType | Action;
const isAsyncAction = (action: AnyAction): action is ActionType =>
  typeof action === "function";

export const useAppDispatch = () => {
  const reduxDispatch = useDispatch<AppDispatch>();

  return (action: AnyAction) => {
    if (isAsyncAction(action)) {
      const actionCallback = () => reduxDispatch(action);

      requestModule.addCallbackToQueue(actionCallback);

      return;
    }

    return reduxDispatch(action);
  };
};

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
